import { render, staticRenderFns } from "./PropertySelect.vue?vue&type=template&id=04200cb1&scoped=true"
import script from "./PropertySelect.vue?vue&type=script&lang=js"
export * from "./PropertySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04200cb1",
  null
  
)

export default component.exports